import React, { Component } from "react";
import { CustomInput } from "reactstrap";

import classes from "./KeyListItem.module.scss";

class KeyListItem extends Component {
  state = {
    checked: true
  };

  toggle = (e, show, hide) => {
    let layerId = `vehicle-${this.props.vehicleId}`;
    let checked;
    if (show) {
      checked = true;
    } else if (hide) {
      checked = false;
    } else {
      checked = e.target.checked;
    }
    this.props.toggle(layerId, checked);
    this.setState({
      checked: checked
    });
  };

  render() {
    return (
      <div className={classes.listItem}>
        <CustomInput
          id={this.props.vehicleId + "-checkbox"}
          className={classes.checkbox}
          type="checkbox"
          checked={this.state.checked}
          onChange={this.toggle}
          color="secondary"
        />
        <div className={classes.color} style={{ backgroundColor: this.props.color }}></div>
        <div className={classes.label}>{this.props.children}</div>
      </div>
    );
  }
}

export default KeyListItem;
